import { OutlookMeetingValue, OutlookSessionType, SessionValue } from "./outlookCreateOrderTypes"

export const isOutlookMeetingValue = (v: SessionValue): v is OutlookMeetingValue =>
    v.type === OutlookSessionType.OUTLOOK_MEETING
